export default __webpack_public_path__ + "static/media/mauquenchy6.c3dda356.jpg";